/**
 * Content-Aware Button Hover Effect
 * Applies mouse-position-based hover effect to buttons with class 'bento-hero__button'
 */

document.addEventListener('DOMContentLoaded', function() {
  initContentAwareButtons();
});

function initContentAwareButtons() {
  const buttons = document.querySelectorAll('.bento-hero__button');
  
  buttons.forEach(button => {
    button.addEventListener('mouseenter', function(e) {
      // Capture mouse position only on initial enter
      const rect = this.getBoundingClientRect();
      const relX = ((e.clientX - rect.left) / rect.width) * 100;
      const relY = ((e.clientY - rect.top) / rect.height) * 100;
      
      // Set CSS custom properties for the hover effect start position
      this.style.setProperty('--mouse-x', relX + '%');
      this.style.setProperty('--mouse-y', relY + '%');
    });
    
    button.addEventListener('mouseleave', function() {
      // Reset position for next hover (optional)
      this.style.setProperty('--mouse-x', '50%');
      this.style.setProperty('--mouse-y', '50%');
    });
  });
}

// Optional: Function to manually initialize buttons added after page load
function reinitContentAwareButtons() {
  initContentAwareButtons();
}